import { DesignProp, GeneralProp } from "../PropCategories";

export const fontWeight = {
  prop: "style-attribute",
  name: "Font Weight",
  nameI18n: "builder_ui.prop_type.styles.font_weight",
  category: [DesignProp, GeneralProp],
  type: "font-weight",
  defaultValue: "500",
} as const;
